import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal } from 'synfrastructure';
import { SubmissionError, reset } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { deleteLesson } from './actions';

import DeleteForm from '../../common/forms/DeleteForm';
import Icon from '../../common/icons/Icon';

class LessonList extends Component {
  static propTypes = {
    lessons: PropTypes.object,
    chapterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    courseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    dispatch: PropTypes.func,
  };

  state = {
    deleteLessonId: null,
    deleteLessonModalVisible: false,
    deleteLessonName: null,
  };

  onDeleteLessonSubmit = () => {
    const { chapterId, courseId, dispatch } = this.props;

    return dispatch(deleteLesson(courseId, chapterId, this.state.deleteLessonId)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleDeleteLessonModal();
      }
    });
  };

  toggleDeleteLessonModal = (id, name) => {
    if (this.state.deleteLessonModalVisible) {
      this.props.dispatch(reset('deleteForm'));
      this.setState(state => ({
        deleteLessonId: null,
        deleteLessonModalVisible: false,
        deleteLessonName: null,
      }));
    } else {
      this.setState(state => ({
        deleteLessonId: id,
        deleteLessonModalVisible: true,
        deleteLessonName: name,
      }));
    }
  };

  render() {
    const { lessons, chapterId, courseId } = this.props;
    const { deleteLessonModalVisible, deleteLessonName } = this.state;

    if (!lessons.get('loaded')) {
      return null;
    }

    return (
      <div className="admin-paper">
        <Modal isVisible={deleteLessonModalVisible} onClose={this.toggleDeleteLessonModal}>
          <DeleteForm
            entityType="Lesson"
            initialValues={{ name: null }}
            onSubmit={this.onDeleteLessonSubmit}
            onCancel={this.toggleDeleteLessonModal}
            requiredConfirmationText={deleteLessonName}
          />
        </Modal>
        <ul className="admin-paper__list" key="course-lessons">
          {lessons.get('data').size ? (
            lessons.get('data').map((lesson, index) => (
              <li key={`lesson-${lesson.get('id')}`}>
                <div className="admin-paper__list__title">
                  <Icon icon="Calendar" />
                  {lesson.get('name')}
                </div>
                <div className="admin-paper__list__actions">
                  <Link to={`/courses/${courseId}/chapters/${chapterId}/lessons/${lesson.get('id')}`}>
                    <Icon icon="Pencil" />
                  </Link>
                  <span onClick={this.toggleDeleteLessonModal.bind(this, lesson.get('id'), lesson.get('name'))}>
                    <Icon icon="Trash" />
                  </span>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no lessons</div>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(state => {
  return {
    lessons: state.courses.lessons,
  };
})(LessonList);



// WEBPACK FOOTER //
// ./src/courses/lessons/LessonList.js